<template>
  <div
    class="p-4 lg:px-12 lg:pb-12 flex flex-col gap-4 w-full pb-12 overscroll-contain"
  >
    <div
      v-highlight-index="4"
      class="lg:text-bold-108 text-bold-54 md:text-bold-72"
    >
      {{ header }}
    </div>
    <div class="flex flex-col gap-3 w-full md:w-1/2 xl:w-1/3">
      <UiLabel class="text-regular-18">{{ t('label.name') }}</UiLabel>
      <UiInput
        class="border-b-0 w-full min-h-[42px]"
        type="text"
        :model-value="userName"
        @update:model-value="userName = $event.toString()"
      />
    </div>

    <div class="flex flex-col gap-3 w-full md:w-1/2 xl:w-1/3">
      <UiLabel class="text-regular-18">{{ t('label.mail') }}</UiLabel>
      <UiInput
        class="border-b-0 w-full min-h-[42px]"
        type="text"
        :placeholder="userStore.user?.email ?? ''"
        :disabled="true"
      />
    </div>

    <div class="flex flex-col gap-3 w-full md:w-1/2 xl:w-1/3">
      <UiLabel class="text-regular-18">{{ t('label.organization') }}</UiLabel>

      <UiInput
        class="border-b-0 w-full min-h-[42px]"
        type="text"
        :placeholder="organizationStore.organization?.name ?? ''"
        :disabled="true"
      />
    </div>

    <div class="flex flex-col w-full h-full md:w-1/2 xl:w-1/3 gap-4 pb-12">
      <UiButton
        class="iq-button-success !px-20 tracking-[0.2rem] lg:px-6 iq-tracking-wide"
        :disabled="!userName"
        @click="saveProfile"
      >
        {{ t('button.save') }}
      </UiButton>

      <UiButton
        class="!iq-button-transparent flex w-full mt-4"
        @click="emit('click:contact')"
        >{{ t('button.contact') }}</UiButton
      >

      <div
        class="mt-2 text-center underline text-regular-12 decoration-iq-grey-text iq-hover !text-iq-grey-text"
        @click="emit('delete:profile')"
      >
        {{ t('label.deleteProfile') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
const organizationStore = useOrganizationStore();
const userStore = useUserStore();
const userName = ref<string>(userStore.user?.name ?? '');
const { t } = useI18n({
  useScope: 'local',
});
const emit = defineEmits<{
  'click:contact': [];
  'delete:profile': [];
}>();

const header = computed(() => t('header'));

async function saveProfile() {
  await userStore.update({ name: userName.value });
}
</script>

<i18n lang="json">
{
  "de": {
    "header": "PROFIL",
    "label": {
      "organization": "Firma",
      "name": "Name",
      "mail": "E-Mail",
      "deleteProfile": "Profil löschen"
    },
    "button": {
      "save": "SPEICHERN",
      "contact": "SUPPORTANFRAGE"
    }
  },
  "en": {
    "header": "PROFILE",
    "label": {
      "organization": "Company",
      "name": "Name",
      "mail": "Email",
      "deleteProfile": "Delete profile"
    },
    "button": {
      "save": "SAVE",
      "contact": "SUPPORT REQUEST"
    }
  }
}
</i18n>
